import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import { readTenantBranding } from '../../utils/tenantBrandingCache';
import { resolvePdfFooterFields } from '../../utils/pdfFooterBranding';
import { resolvePdfBrandColors, resolvePdfFooterSurfaceColor } from '../../utils/pdfBrandColors';

const styles = StyleSheet.create({
  wrap: {
    marginTop: 8,
    width: '100%',
  },
  body: {
    flexDirection: 'row',
    paddingVertical: 8,
    paddingHorizontal: 10,
    width: '100%',
  },
  colLeft: {
    width: '50%',
    paddingRight: 10,
    borderRightWidth: 1,
    borderRightColor: '#cccccc',
  },
  colRight: {
    width: '50%',
    paddingLeft: 10,
    justifyContent: 'flex-start',
  },
  textLeft: {
    fontSize: 7,
    lineHeight: 1.35,
    color: '#111111',
    marginBottom: 3,
  },
  textRight: {
    fontSize: 7,
    lineHeight: 1.35,
    color: '#111111',
    textAlign: 'right',
    marginBottom: 2,
  },
  bold: {
    fontFamily: 'Helvetica-Bold',
  },
});

function AddressLines({ addressBlock }) {
  const lines = String(addressBlock || '')
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);
  if (!lines.length) return null;
  return (
    <View>
      <Text style={styles.textLeft}>
        <Text style={styles.bold}>Head Office : </Text>
        {lines[0]}
      </Text>
      {lines.slice(1).map((line, idx) => (
        <Text key={`addr-${idx}`} style={styles.textLeft}>
          {line}
        </Text>
      ))}
    </View>
  );
}

/**
 * PDF document footer: contact block (left) and services list (right).
 * Content comes from Organization & branding (tenant settings); defaults match the legacy footer image.
 */
export default function FooterWithImage({ branding: brandingProp }) {
  const branding = brandingProp ?? readTenantBranding();
  const { primary, secondary } = resolvePdfBrandColors(branding);
  const f = resolvePdfFooterFields(branding);
  const footerBg = resolvePdfFooterSurfaceColor(branding);

  return (
    <View style={styles.wrap} wrap={false}>
      <View style={{ height: 2, backgroundColor: secondary, width: '100%' }} />
      <View style={{ height: 2, backgroundColor: primary, width: '100%' }} />
      <View style={[styles.body, { backgroundColor: footerBg }]}>
        <View style={styles.colLeft}>
          <AddressLines addressBlock={f.addressBlock} />
          {f.supportPhone ? (
            <Text style={styles.textLeft}>{f.supportPhone}</Text>
          ) : null}
          <Text style={styles.textLeft}>
            <Text style={styles.bold}>E : </Text>
            {f.supportEmail}
            {f.footerWebsite ? (
              <>
                {'   '}
                <Text style={styles.bold}>W : </Text>
                {f.footerWebsite}
              </>
            ) : null}
          </Text>
          {f.footerTagline ? (
            <Text style={[styles.textLeft, styles.bold]}>{f.footerTagline}</Text>
          ) : null}
        </View>
        <View style={styles.colRight}>
          {f.serviceLines.map((line, idx) => (
            <Text key={`svc-${idx}`} style={styles.textRight}>
              {line}
            </Text>
          ))}
        </View>
      </View>
    </View>
  );
}
